// Author liang gang qiang
// Date 2021-11-24 14:30:39

class MintalMesPrdDowntimePlan {
constructor({
        id = null,
        locationId = '',
        locationName = '',
        stopMonth = '',
        hours = '',
        description = '',
        remark = ''}
= {}) {
    this.id = id;
    this.locationId = locationId;
    this.locationName = locationName;
    this.stopMonth = stopMonth;
    this.hours = hours;
    this.description = description;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdDowntimePlan();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'stopMonth',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.grid.stopMonth',
        sortable: true,
        form: {
        type: 'year_month'
        }
        },
        {
        key: 'hours',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.grid.hours',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.grid.description',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    locationIdFilter : '',
    locationNameFilter : '',
    stopMonthRteFilter : '',
    stopMonthLteFilter : '',
    hoursFilter : '',
    descriptionFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'locationNameFilter',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.filter.locationName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId": "id"}'
                }
        },
        {
        key: 'stopMonthRteFilter',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.filter.stopMonthRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'stopMonthLteFilter',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.filter.stopMonthLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'hoursFilter',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.filter.hours',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'descriptionFilter',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.filter.description',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.entity.locationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId": "id"}'
                }
        },
        {
        key: 'stopMonth',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.entity.stopMonth',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'hours',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.entity.hours',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'description',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdDowntimePlan.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdDowntimePlan, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
